import StaffScanner from '../staff/Scanner';
export default StaffScanner;
